import { mapComponentTypesV2ToV1 } from 'util/misc'

interface ComponentWithCode {
  code: string
  type?: string
}

export async function activateComponentsIfNeeded(
  components: ComponentWithCode[],
  defaultComponentType: string = 'inverter'
): Promise<void> {
  const componentsToActivate = components
    .filter((component) => {
      const componentType = (component.type || defaultComponentType) as any
      const activateComponentData = window.AccountHelper.getComponentActivationFromCode(
        component.code,
        mapComponentTypesV2ToV1(componentType)
      )
      return activateComponentData === undefined
    })
    .map((component) => component.code)

  if (componentsToActivate.length === 0) {
    return
  }

  await new Promise<void>((resolve, reject) => {
    window.AccountHelper.activateComponents(
      componentsToActivate,
      () => {
        resolve()
      },
      () => {
        console.error('Error activating components:', componentsToActivate)
        reject(new Error(`Failed to activate components: ${componentsToActivate.join(', ')}`))
      }
    )
  })
}
